(function () {
  'use strict';

  angular.module('ringbaPortal').component('adjustmentPreview', {
    bindings: {
      adjustmentCurrentPreviewLabel: '@',
      adjustmentAmountPreviewLabel: '@',
      adjustmentAdjustedPreviewLabel: '@',
      currentAmount: '<',
      amount: '<'
    },
    controller: AdjustmentPreviewController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/call-adjustment-form/adjustment-preview.view.html'
  });

  function AdjustmentPreviewController() { }
})();
